/**
 * custom-blue 样式调试
 * CUSTOM_BLUE_SUCCESS_DEBUG — 强制进入成功页
 * CUSTOM_BLUE_FORCE_ENTRY_POPUP — 强制打开进入页付款账号弹窗
 */
export const CUSTOM_BLUE_SUCCESS_DEBUG = false;
export const CUSTOM_BLUE_FORCE_ENTRY_POPUP = false;

export function applyCustomBlueSuccessDebug(vm) {
  if (vm.themeId !== 'custom-blue') {
    return;
  }

  if (CUSTOM_BLUE_FORCE_ENTRY_POPUP) {
    vm.showCustomBlueSuccessPage = false;
    vm.paymentAccountShow = true;
    vm.paymentAccountVerifyShow = false;
    return;
  }

  if (!CUSTOM_BLUE_SUCCESS_DEBUG) {
    return;
  }

  if (!vm.repaymentData.cardData) {
    vm.$set(vm.repaymentData, 'cardData', {});
  }

  const cardData = vm.repaymentData.cardData;
  if (!cardData.userSubmitAccountNumber) {
    vm.$set(cardData, 'userSubmitAccountNumber', '0203333333');
  }
  if (!cardData.bankName) {
    vm.$set(cardData, 'bankName', 'vodafone');
  }
  if (!cardData.amount) {
    vm.$set(cardData, 'amount', '10.00');
  }

  vm.collectionDataStep = 1;
  vm.collectionData = {
    transactionNums: 1,
    collectedAmount: cardData.amount,
    collectDetails: [
      {
        bankTransactionReference: 'CWPC456132321313',
        destinationAccountNumber: cardData.userSubmitAccountNumber,
        amount: cardData.amount,
        transactionTime: '',
      },
    ],
  };
  vm.showCustomBlueSuccessPage = true;
  vm.paymentAccountShow = false;
  vm.paymentAccountVerifyShow = false;
}
